import { SettingsI } from '../interfaces/settings.interface'
import { SettingsService } from '../services/settings.service'
import {
    AttachWabaTemplatesPayload,
    SettingFilters,
    SettingsGetListResponseT,
    SettingsGetNotificationItResponseT,
    SettingsGetNotificationsItListResponseT,
    SettingsGetNotificationsListResponseT,
    SettingsGetWabaTemplateCategoriesResponseT,
    SettingsGetWabaTemplatesParams,
    SettingsGetWabaTemplatesResponse,
    SettingsWabaTemplatesCreatePayload,
    SettingsWabaTemplatesGetCategoriesResponse,
    SettingsWabaTemplatesGetLanguagesResponse,
    SettingsWabaTemplatesGetStatusesResponse,
    SettingsWabaTemplatesUpdatePayload,
} from '../types/settings.types'

const settingsService = new SettingsService()

class SettingsRealisation implements SettingsI {
    getList(filters: SettingFilters): Promise<SettingsGetListResponseT> {
        return settingsService.getList(filters)
    }

    updateSettingState(setting_id: number, value: string): Promise<void> {
        return settingsService.updateSettingState(setting_id, value)
    }

    getNotificationsList(filters: SettingFilters): Promise<SettingsGetNotificationsListResponseT> {
        return settingsService.getNotificationsList(filters)
    }

    updateNotificationSettingState(setting_id: number, is_active: boolean): Promise<void> {
        return settingsService.updateNotificationSettingState(setting_id, is_active)
    }

    getNotificationIt(id: number): Promise<SettingsGetNotificationItResponseT> {
        return settingsService.getNotificationIt(id)
    }

    editTemplateNotificationIt(id: number, body: string): Promise<void> {
        return settingsService.editTemplateNotificationIt(id, body)
    }

    editCompaniesNotificationIt(settingsId: number, companyIds: number[]): Promise<void> {
        return settingsService.editCompaniesNotificationIt(settingsId, companyIds)
    }

    getNotificationsItList(
        page: number,
        limit: number
    ): Promise<SettingsGetNotificationsItListResponseT> {
        return settingsService.getNotificationsItList(page, limit)
    }

    enableNotificationIt(settingsId: number): Promise<void> {
        return settingsService.enableNotificationIt(settingsId)
    }

    disableNotificationIt(settingsId: number): Promise<void> {
        return settingsService.disableNotificationIt(settingsId)
    }

    getWabaTemplates(params: SettingsGetWabaTemplatesParams): Promise<SettingsGetWabaTemplatesResponse> {
        return settingsService.getWabaTemplates(params)
    }

    wabaTemplatesGetLanguages(): Promise<SettingsWabaTemplatesGetLanguagesResponse> {
        return settingsService.wabaTemplatesGetLanguages()
    }

    wabaTemplatesGetStatuses(): Promise<SettingsWabaTemplatesGetStatusesResponse> {
        return settingsService.wabaTemplatesGetStatuses()
    }

    wabaTemplatesGetCategories(): Promise<SettingsWabaTemplatesGetCategoriesResponse> {
        return settingsService.wabaTemplatesGetCategories()
    }

    createWabaTemplate(payload: SettingsWabaTemplatesCreatePayload): Promise<void> {
        return settingsService.createWabaTemplate(payload)
    }

    updateWabaTemplate(id: number, payload: SettingsWabaTemplatesUpdatePayload): Promise<void> {
        return settingsService.updateWabaTemplate(id, payload)
    }

    deleteWabaTemplate(id: number): Promise<void> {
        return settingsService.deleteWabaTemplate(id)
    }

    attachWabaTemplates(settingsId: number, payload: AttachWabaTemplatesPayload): Promise<void> {
        return settingsService.attachWabaTemplates(settingsId, payload)
    }

    syncWabaTemplate(templateId: number): Promise<void> {
        return settingsService.syncWabaTemplate(templateId)
    }

    syncWabaTemplates(): Promise<void> {
        return settingsService.syncWabaTemplates()
    }

    getWabaTemplateCategories(): Promise<SettingsGetWabaTemplateCategoriesResponseT> {
        return settingsService.getWabaTemplateCategories()
    }
}

export const settings = new SettingsRealisation()
